export const CLIENT_CONTACTS_KEYS = {
  all: ['client-contacts'] as const,
  byOrg: (orgId: string) => ['client-contacts', orgId] as const,
  byClient: (orgId: string, clientId: string) => ['client-contacts', orgId, clientId] as const,
  contact: (orgId: string, clientId: string, contactId: string) =>
    ['client-contacts', orgId, clientId, contactId] as const,
};
